import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import { Dispatch } from 'redux';
import { Dashboard } from 'components';
import { fetchDashboardAlerts, fetchDashboardMetrics } from 'actions';
import { selectUserId } from 'selectors';
import { GaugeType, GaugeData, GeoLocationPoint } from 'model';
import { selectDashbaordAlertPoints, selectDashbaordGauges, selectDashbaordIsLoading } from 'selectors/Dashboard';


type SelectedValues = {
  userId?: string | null;
  gauges: Map<GaugeType, GaugeData>;
  isLoading: boolean;
  geoLocationPoints: GeoLocationPoint<Location>[];
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  userId: selectUserId(),
  gauges: selectDashbaordGauges(),
  isLoading: selectDashbaordIsLoading(),
  geoLocationPoints: selectDashbaordAlertPoints(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchDashboardMetrics: (userId: string) => dispatch(fetchDashboardMetrics(userId)),
  fetchDashboardAlerts: (userId: string) => dispatch(fetchDashboardAlerts(userId)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
